import { Component, Input } from '@angular/core';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-btn-link',
  standalone: true,
  imports: [SharedModule, RouterModule],
  templateUrl: './btn-link.component.html',
  styleUrls: ['./btn-link.component.scss']
})
export class BtnLinkComponent {
  @Input() linkId: string = "btn-link";
  @Input() linkStyle: 'primary' | 'secondary' | 'elevated' | 'outline' | 'text' = 'primary';
  @Input() linkClass?: string;
  @Input() linkType?: 'href' | 'routerLink' = 'routerLink';
  @Input() linkTarget?: '_blank' | '_self' = '_self';
  @Input() linkUrl: string;
  @Input() linkTitle: string;
  @Input() matIcon?: string;
  @Input() matIconFilled?: boolean = false;
  @Input() matIconPosition?: 'start' | 'end' = 'end';
  @Input() matIconSize?: number = 18;
  @Input() linkReturnUrl: string; // @LSegovia -> Obsolete, reemplazar por queryParams[] el día que sea posible
  @Input() importeUrl: string; // @LSegovia -> Obsolete, reemplazar por queryParams[] el día que sea posible
  //@Input() queryParams: BtnQueryParam[]; // @LSegovia -> Utilizar esto en lugar de los otros dos parámetros (Crear model)
}
